// eslint-disable-next-line import/no-anonymous-default-export
export default {
    dark:{
      "colorPrimary": "#4270ed",
      "colorInfo": "#3d9cea",
      "fontSize": 14,
      "borderRadius": 6,
      "colorLink": "#4270ed",
      "colorLinkHover": "#6476e3",
      "colorLinkActive": "#6476e3",
      "colorLinkFocus": "#6476e3"
    },
    light:{
      "colorPrimary": "#4270ed",
      "colorInfo": "#3d9cea",
      "fontSize": 14,
      "borderRadius": 6,
      "colorLink": "#4270ed",
      "colorLinkHover": "#6476e3",
      "colorLinkActive": "#6476e3",
      "colorLinkFocus": "#6476e3"
    }
  }